import React, { Component } from 'react';
import StartPage from '../PAGES/StartPage';
import GamePage from '../PAGES/GamePage';
import HelpPage from '../PAGES/HelpPage';
import { START_PAGE, GAME_PAGE, SKILL_PAGE, HELP_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';
import { updateStats } from '../REDUX/actions';
import SkillPage from '../PAGES/SkillPage';

class Triomino extends Component {
  componentDidMount() {
    if (!this.props.page) {
      this.props.goToPage(START_PAGE);
    }
  }

  render() {
    const page = this.props.page || START_PAGE;

    return (
      <>
        {page === START_PAGE ? <StartPage /> : null}
        {page === HELP_PAGE ? <HelpPage /> : null}
        {page === SKILL_PAGE ? <SkillPage /> : null}
        {page === GAME_PAGE ? <GamePage /> : null}
      </>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, updateStats }
)(Triomino);
